import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { Ope } from 'src/app/models/Ope';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';
import { CardComponent } from './card/card.component';
import { ErrorComponent } from 'src/app/global-composants/error/error.component';
import { PaginatorModule } from 'primeng/paginator';
import { NgxPaginationModule } from 'ngx-pagination';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-liste-cards',
  templateUrl: './liste-cards.component.html',
  imports : [CommonModule,CardComponent,ErrorComponent,PaginatorModule,NgxPaginationModule],
  styleUrls: ['./liste-cards.component.scss']
})
export class ListeCardsComponent implements OnInit, OnDestroy {

  listopeRecu!: Ope[];
  page: any;
  affichenotfound: boolean = false;
  affichebadreq: boolean = false;
  private destroy$!: Subject<boolean>;

  constructor(public share: shareOpeSevices) {
    this.destroy$ = new Subject<boolean>();
  }

  ngOnInit() {
    this.share.datasourceOpe$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.listopeRecu = data;
      this.page = 1;
    });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}